import { ReportDownloadService } from "../services";
import { mapGetters, mapActions } from "vuex";
import {
  LoanExcelFileSuccessMessage,
  LoanExcelFileErrorMessage,
} from "../helpers/constant";
import {
  GET_AUTH_INFORMATION,
  SET_LOADER_VISIBILITY,
} from "../helpers/vuex-constants";
export default {
  computed: {
    ...mapGetters({
      getAuthInformation: GET_AUTH_INFORMATION,
    }),
  },
  methods: {
    ...mapActions({
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    async getExcelFileStream(data, fileName) {
      data.iceInput = "";
      this.setLoaderVisibility(false);
      let apiReponse = await ReportDownloadService.getLoanExcelFile(data);
      this.setLoaderVisibility(false);
      this.excelFileDownload(
        apiReponse,
        LoanExcelFileSuccessMessage,
        LoanExcelFileErrorMessage,
        fileName
      );
    },
    async getPDFFileStream(flag, fileName, subownerId, jsonData) {
      this.setLoaderVisibility(true);
      let payload = this.preparePDFFileModel(
        flag,
        fileName,
        subownerId,
        jsonData
      );
      let apiReponse = await ReportDownloadService.preparePDFFile(payload);
      this.setLoaderVisibility(false);
      this.DownloadFile(
        apiReponse,
        LoanExcelFileSuccessMessage,
        LoanExcelFileErrorMessage
      );
    },

    preparePDFFileModel(flag, fileName, subownerId, jsonData) {
      let obj = {
        clientId: this.getAuthInformation.clientId,
        companyId: this.getAuthInformation.companyId,
        adviserId: this.getAuthInformation.adviserId,
        reportTypeId: 21,
        isOutPutInword: flag,
        reportName: fileName,
        subowners: subownerId,
        jsonData: jsonData,
      };
      return obj;
    },

    DownloadFile(responseData, successMessage, errorMessage) {
      let resp = responseData;
      if (resp) {
        let fileName = resp.data.fileurl;
        if (fileName && fileName.includes(".pdf")) {
          fileName = fileName.substring(
            fileName.lastIndexOf("/") + 1,
            fileName.lastIndexOf(".pdf")
          );
          this.setNotificationSummary({
            isShow: true,
            variation: "success",
            text: successMessage,
          });
          let downloadurl = ReportDownloadService.downloadPDFFile(
            fileName,
            this.getAuthInformation.wrapCode
          );

          window.location.href = downloadurl;
        } else {
          this.setNotificationSummary({
            isShow: true,
            variation: "error",
            text: errorMessage,
          });
        }
      }
    },
    excelFileDownload(apiResponse, successMessage, errorMessage, fileName) {
      if (apiResponse && apiResponse.status == 200) {
        this.downloadFile(apiResponse.data, fileName);
        this.setNotificationSummary({
          isShow: true,
          variation: "success",
          text: successMessage,
        });
      } else {
        this.setNotificationSummary({
          isShow: true,
          variation: "error",
          text: errorMessage,
        });
      }
    },

    downloadFile(data, fileName) {
      const contentType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const blob = new Blob([data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = fileName + ".xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    },
  },
};
